/**
 *
 * @param {Object} state
 * @param {String} token
 */
const SET_DALENYS_TOKEN = (state, token) => {
  state.dalenysToken = token;
};

/**
 *
 * @param {Object} state
 * @param {String} error
 */

const SET_TOKENIZATION_ERROR = (state, error) => {
  state.tokenizationError = error;
};

/**
 *
 * @param {Object} state
 * @param {Object} method
 */

const SET_CHOOSEN_METHOD = (state, method) => {
  state.choosenMethod = method;
};

/**
 *
 * @param {Object} state
 * @param {Array} methods
 */

const SET_METHODS = (state, methods) => {
  state.methods = methods;
};

/**
 *
 * @param {Object} state
 * @param {Object} methods
 */

const SET_HOSTED_FIELDS = (state, hostedFields) => {
  state.hostedFields = hostedFields;
};

export default {
  SET_DALENYS_TOKEN,
  SET_TOKENIZATION_ERROR,
  SET_METHODS,
  SET_CHOOSEN_METHOD,
  SET_HOSTED_FIELDS,
};
